import { cn } from '@/utils/tailwind-util';
// @ts-nocheck
import { Switch } from '@headlessui/react';
import React from 'react';

export interface SwitchProps {
  id?: string;
  isChecked?: boolean;
  isDisabled?: boolean;
  onChange?: (enabled: boolean) => void;
  size?: 'sx' | 'md';
}

const ToggleButton: React.FC<SwitchProps> = ({
  id,
  isChecked = false,
  isDisabled = false,
  onChange,
  size = 'md',
}) => {
  return (
    <Switch
      id={id}
      disabled={isDisabled}
      checked={isChecked}
      onChange={onChange}
      className={cn(
        'relative inline-flex flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75',
        isDisabled
          ? 'bg-primary-300'
          : isChecked
          ? 'bg-primary'
          : 'bg-primary-100',
        size == 'sx' ? 'h-[16px] w-[28px]' : 'h-[38px] w-[74px]'
      )}
    >
      <span className="sr-only">Use setting</span>
      <span
        aria-hidden="true"
        className={cn(
          'pointer-events-none inline-block transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
          isChecked
            ? size == 'sx'
              ? 'translate-x-3'
              : 'translate-x-9'
            : 'translate-x-0',
          size == 'sx' ? 'h-[12px] w-[12px]' : 'h-[34px] w-[34px]'
        )}
      />
    </Switch>
  );
};

export default ToggleButton;
